export const OWNER_TOKEN_EVENT = 'owner-token-updated';

export const dispatchOwnerTokenEvent = () => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(OWNER_TOKEN_EVENT));
  } catch {}
};
